import { useCallback, useMemo } from "react";
import { useLocation } from "@aviv-unified-frontend/runtime/router";
import { KNOWN_SUBPATHS } from "../constants";
/**
 * ℹ️  This hook is generate base URL by matching current pathname with known subpaths.
 *
 * @returns A function that returns the base URL as a string.
 */
const useGetBaseRoute = () => {
    const location = useLocation();
    let baseUrl = "";
    // Try to match current pathname with a known subpath to properly compute the route baseUrl
    for (const subPath of KNOWN_SUBPATHS) {
        const matches = subPath.exec(location.pathname);
        if (matches) {
            baseUrl = matches[1];
            break;
        }
    }
    const computeRoute = useCallback(() => {
        return () => `${baseUrl}`;
    }, [baseUrl]);
    const baseRoute = useMemo(() => computeRoute(), [computeRoute]);
    return baseRoute;
};
export { useGetBaseRoute };
